export function useIsProduction() {
  return process.env.REACT_APP_ENVIRONMENT === "production";
}
